import { isEqual, xorWith } from 'lodash'

export default function arrayDifference(originalArray, newArray) {
  return xorWith(originalArray, newArray, isEqual)
}
